import { useEffect } from 'react';

import { useAppLoadTelemetryTime, useTelemetry } from '../../../../common/hooks';

export const usePublishTermsLoadingTelemetry = () => {
  const { incrementLoadPagePerfomanceTimer } = useTelemetry();
  const { getAppLoadTimeTelemetry } = useAppLoadTelemetryTime();

  useEffect(() => {
    // Скорость рендера приложения оцениваем только на клиенте
    if (typeof window !== 'undefined') {
      incrementLoadPagePerfomanceTimer('lcp', getAppLoadTimeTelemetry());
    }
  }, []);
};
